import main from './main.vue'
const commonTabsV3 = {
  install:function(Vue) {
    Vue.component(main.name, main)
  }
}
// 导出该组件
export default commonTabsV3